module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lyra/lyr_pn-658b94d09d7ba1b17573a2ef5bc043d8.gif";